import { combineReducers } from "redux-immutable";

import { reducer as layoutReducer } from "./Layout";
import { reducer as projectReducer } from "./Project";
import { reducer as markReducer } from "./Mark";
import { reducer as scoreReducer } from "./Score";

import { reducer as factorReducer } from "../pages/Factor/store";

const reducer = combineReducers({
  layout: layoutReducer,
  factor: factorReducer,
  project: projectReducer,
  mark: markReducer,
  score: scoreReducer
});

export default reducer;
